const LeftArrow = ({ width, fill = "#414042" }) => {
    return (
        <div className={`left-arrow ${width} h-auto`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 107 68">
                <g fill={fill}>
                    <path d="M106.378 30.552H7.207v7.09h99.171z"></path>
                    <path
                        d="M33.208 67.279L.008 34.097 33.208.914l5.017 5.015-28.184 28.168 28.184 28.168z"
                    ></path>
                </g>
            </svg>
        </div>
    )
}

export default LeftArrow
